<template>
    <div class="container-xxl py-5">
        <!-- İsim ve Mesaj Girişleri -->
        <div class="mb-3">
            <label for="name" class="form-label fw-bold">Üye İsmi:</label>
            <input id="name" v-model="name" type="text" class="form-control" />
        </div>

        <div class="mb-3">
            <label for="message" class="form-label fw-bold">Dernek için ne yaptı:</label>

            <input id="message" v-model="message" type="text" class="form-control" />
        </div>
        <div class="mb-3">
            <button v-if="!loading" @click="generateMessage" class="btn btn-primary form-control">
                {{ !loading ? "Mesaj Oluştur" : "Bekle" }}
            </button>
        </div>

        <!-- Belge Alanı -->
        <div ref="captureArea" class="certificate-area mx-auto">
            <img src="/img/frame2.png" alt="Çerçeve" class="bg-image" />

            <div class="text-center mb-4">
                <img src="/img/logo2.jpeg" alt="Dernek Logosu" class="logo-top" />
                <h2 class="title mt-3">Teşekkür ve Minnet</h2>
            </div>

            <div class="text-center my-2">
                <div>
                    Sayın <strong class="name-display">{{ name || '' }}</strong>
                </div>
                <p class="message-display mt-3">{{ message }}</p>
            </div>

            <div class="text-center mt-5">
                <h5 class="footer">Başkent Ağrılılar Derneği</h5>
                <img src="/img/logo.jpg" alt="Alt Logo" class="logo-bottom" />
            </div>
        </div>

        <!-- Butonlar -->
        <div class="text-center mt-4">
            <button @click="downloadAsJpeg" class="btn btn-success">
                JPEG Olarak Kaydet
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import html2canvas from "html2canvas";
import OpenAI from "openai";
const name = ref("");
const message = ref("");
const captureArea = ref(null);
const loading = ref(false);

const downloadAsJpeg = async () => {
    if (!captureArea.value) return;

    const canvas = await html2canvas(captureArea.value, {
        backgroundColor: null,
        scale: 2,
        useCORS: true,
    });

    const link = document.createElement("a");
    link.download = "tesekkur-belgesi.jpeg";
    link.href = canvas.toDataURL("image/jpeg", 1.0);
    link.click();
};

const generateMessage = async () => {
    if (!name.value) {
        alert("Lütfen bir isim girin.");
        return;
    }

    try {
        const prompt = `Derneğimiz adına üyemize özel, saygı ve minnet içeren kısa (2-3 cümlelik) bir teşekkür mesajı oluştur. kendisi ${message.value}. mesajda yaptıgı işe değin onu öv ve diğerlerini teşvik et, mesaj kısa ve net olsun. mesaja paramatre veya isim ekleme
    `;

        loading.value = true

        const openai = new OpenAI({
            apiKey: "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",
            dangerouslyAllowBrowser: true
        });

        const completion = openai.chat.completions.create({
            model: "gpt-4o-mini",
            store: true,
            messages: [
                { "role": "user", "content": prompt },
            ],
        });

        completion.then((result) => {
            loading.value = false
            message.value = result.choices[0].message.content
            console.log(result.choices[0].message)
        });


    } catch (error) {
        loading.value = false
        console.error("Mesaj oluşturulurken hata:", error);
        alert("Mesaj oluşturulamadı. Lütfen tekrar deneyin.");
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Poppins:wght@400;600&display=swap');

.certificate-area {
    position: relative;
    min-width: 600px; /* <- Minimum genişlik belirlendi */
    max-width: 800px;
    width: 100%; /* genişlik ekran boyutuna göre ayarlanır ama min değerden küçük olamaz */
    padding: 3rem;
    margin: 12px auto;
    border-radius: 15px;
    overflow: hidden;
    background-color: white;
    font-family: 'Poppins', sans-serif;

    /* Otomatik yükseklik */
    height: auto;
}
.bg-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: fill;
    z-index: 0;
}

.certificate-area>*:not(.bg-image) {
    position: relative;
    z-index: 1;
}

.logo-top {
    height: 100px;
    margin-bottom: 10px;
}

.logo-bottom {
    height: 80px;
    margin-top: 10px;
}

.title {
    font-family: 'Great Vibes', cursive;
    font-size: 3rem;
    color: #e55626;
}

.name-display {
    font-family: 'Great Vibes', cursive;
    font-size: 2.2rem;
    color: #333;
}

.message-display {
    font-family: 'Poppins';
    font-size: 1.8rem;
    color: #444;
}

.footer {
    font-family: 'Great Vibes', cursive;
    font-size: 1.8rem;
    color: #e55626;
}
</style>